import styled from "styled-components";

export const Disclaimer = styled.div`
  text-align: center;
  font-size: 14px;
  margin: 0 36px;
`;
